/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  Table,
  TextInput,
} from "flowbite-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import type { FC } from "react";
import * as XLSX from "xlsx";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useEffect, useState, useRef } from "react";
import {
  HiBell,
  HiCheckCircle,
  HiChevronLeft,
  HiChevronRight,
  HiCog,
  HiDocumentDownload,
  HiDotsVertical,
  HiExclamationCircle,
  HiHome,
  HiOutlineExclamationCircle,
  HiOutlinePencilAlt,
  HiPlus,
  HiSave,
  HiTrash,
  HiUserAdd,
  HiUpload,
  HiXCircle,
  HiDocumentText,
} from "react-icons/hi";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import { FadeLoader } from "react-spinners";

import { NotificationBellDropdown } from "./navbar";
import { useAppContext } from "../context/AppContext";
import { companyService, contactService, dealService } from "../services/main";
const UserListPage: FC = function () {
  return (
    <NavbarSidebarLayout isFooter={false}>
      <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <div className="mb-1 w-full">
          <div className="mb-4">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item>
                <div className="flex items-center gap-x-3">
                  <HiHome className="text-xl" />
                  <span className="dark:text-white">Home</span>
                </div>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/users/list">Users</Breadcrumb.Item>
              <Breadcrumb.Item>List</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
              All users
            </h1>
          </div>
          <div className="sm:flex">
            <div className="mb-3 hidden items-center dark:divide-gray-700 sm:mb-0 sm:flex sm:divide-x sm:divide-gray-100">
              <form className="lg:pr-3">
                <Label htmlFor="users-search" className="sr-only">
                  Search
                </Label>
                <div className="relative mt-1 lg:w-64 xl:w-96">
                  <TextInput
                    id="users-search"
                    name="users-search"
                    placeholder="Search for users"
                  />
                </div>
              </form>
              <div className="mt-3 flex space-x-1 pl-0 sm:mt-0 sm:pl-2">
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Configure</span>
                  <HiCog className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Delete</span>
                  <HiTrash className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Purge</span>
                  <HiExclamationCircle className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Settings</span>
                  <HiDotsVertical className="text-2xl" />
                </a>
              </div>
            </div>
            <div className="ml-auto flex items-center space-x-2 sm:space-x-3">
              <AddDealModal />
              <Button color="gray">
                <div className="flex items-center gap-x-3">
                  <HiDocumentDownload className="text-xl" />
                  <span>Export</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden shadow">
              {/* <AllDealsTable /> */}
            </div>
          </div>
        </div>
      </div>
    </NavbarSidebarLayout>
  );
};


// Helper function to generate tag options including custom tags
const generateTagOptions = (deals: any[]) => {
  const baseOptions = [
    { value: "todo", label: "Todo" },
    { value: "in-progress", label: "In Progress" },
    { value: "done", label: "Done" },
    { value: "closed", label: "Closed" },
  ];
  
  const customTags = deals
    .filter(deal => Array.isArray(deal.tags))
    .flatMap(deal => deal.tags)
    .filter(tag => !["todo", "in-progress", "done", "closed"].includes(tag))
    .filter((tag, index, arr) => arr.indexOf(tag) === index) // Remove duplicates
    .map(tag => ({ value: tag, label: tag.charAt(0).toUpperCase() + tag.slice(1).replace('-', ' ') }));
  
  return [...baseOptions, ...customTags];
};

const initialFormData = {
  dealName: "",
  description: "",
  companyId: "",
  amount: "",
  expectedClosingDate: "",
  stage: "Opportunity", // default as per model
  remark: "", // New field for remarks
  tags: [], // Array of tags for multiple tags
  contactIds: [] as number[], // Array from Select multi-select
};


export const AddDealModal: FC = () => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const { deals, setDeals, setCompanies, companies, setContacts, contacts } = useAppContext();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [formData, setFormData] = useState(initialFormData) as any;
  const [customTags, setCustomTags] = useState<string[]>([]);
  const companyOptions = companies.map((company: any) => ({
    value: company.id,
    label: company.name,
  }));

  const stageOptions = [
    "Opportunity",
    "Proposal Sent",
    "In Negotiation",
    "Won",
    "Lost",
    "Delayed",
  ].map((stage) => ({
    value: stage,
    label: stage,
  }));

  // Generate tag options including custom tags created in this session
  const tagOptions = generateTagOptions(deals).concat(
    customTags
      .filter(tag => !deals.some((deal: any) => Array.isArray(deal.tags) && deal.tags.includes(tag)))
      .map(tag => ({ value: tag, label: tag.charAt(0).toUpperCase() + tag.slice(1).replace('-', ' ') }))
  );

  const contactOptions = contacts.map((contact: any) => ({
    value: contact.id,
    label: `${contact.firstName} ${contact.lastName}`,
  }));


  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await companyService.listCompanies();
        setCompanies(response.data.companies);
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    };

    const fetchContacts = async () => {
      try {
        const response = await contactService.listContacts();
        setContacts(response.data.contacts);
      } catch (error) {
        console.error("Failed to fetch contacts", error);
      }
    };

    fetchCompanies();
    fetchContacts();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;

    if (name === "amount") {
      setFormData((prev: any) => ({
        ...prev,
        amount: value,
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTagsChange = (selectedOptions: any) => {
    const newTags = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
    
    // Track new custom tags that aren't in existing deals
    const existingTags = deals
      .filter((deal: any) => Array.isArray(deal.tags))
      .flatMap((deal: any) => deal.tags);
    
    const newCustomTags = newTags.filter((tag: string) => 
      !["todo", "in-progress", "done", "closed"].includes(tag) && 
      !existingTags.includes(tag)
    );
    
    setCustomTags(prev => [...new Set([...prev, ...newCustomTags])]);
    
    setFormData((prev: any) => ({
      ...prev,
      tags: newTags,
    }));
  };

  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await dealService.listDeals();
      const sorted = response.data.deals.sort((a: any, b: any) => a.id - b.id);
      setDeals(sorted);
    } catch (error) {
      console.error("Failed to refresh deals", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddDeal = async () => {
    // Validate required fields
    if (!formData.dealName?.trim()) {
      toast.error("Deal name is required");
      return;
    }
    if (!formData.companyId) {
      toast.error("Please select a company");
      return;
    }
    if (!formData.amount || isNaN(parseFloat(formData.amount))) {
      toast.error("Valid amount is required");
      return;
    }
    if (!formData.expectedClosingDate) {
      toast.error("Expected closing date is required");
      return;
    }

    try {
      setLoading(true);

      // Ensure contactIds is always an array (form may have "" or array from Select)
      const contactIds = Array.isArray(formData.contactIds)
        ? formData.contactIds
        : [];

      const payload = {
        ...formData,
        contactIds,
        amount: parseFloat(formData.amount),
        companyId: Number(formData.companyId),
        expectedClosingDate: new Date(formData.expectedClosingDate).toISOString(),
        userId: user.id || user._id || 1, // Try both id and _id, fallback to 1
      };

      const response = await dealService.createDeal(payload);
      await onUpdate();
      setFormData(initialFormData);
      setOpen(false);
      toast.success("Deal added successfully!");
    } catch (error) {
      console.error("Failed to add deal", error);
      toast.error("Failed to add deal. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const handleDealDataExport = () => {
    const excludeFields = ["id", "accountManagerId", "createdAt", "updatedAt"];

    const transformed = deals.map((item: any) => {
      const result: any = {};

      Object.entries(item).forEach(([key, value]: any) => {
        if (excludeFields.includes(key)) return;

        if (key === "company" && value && typeof value === "object") {
          result["company"] = value.name; // You can add more fields if needed
        } else if (key === "contacts" && Array.isArray(value)) {
          result["contacts"] = value
            .map((contact) => `${contact.firstName} ${contact.lastName}`)
            .join(", ");
        } else if (value && typeof value === "object" && !Array.isArray(value)) {
          // Skip other nested objects
          return;
        } else {
          result[key] = value;
        }
      });

      return result;
    });

    const worksheet = XLSX.utils.json_to_sheet(transformed);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Deals");

    XLSX.writeFile(workbook, "deals_export.xlsx");
  };

  return (
    <>

      <Button color="primary" onClick={() => {
        setOpen(true)
      }}>
        <div className="flex items-center gap-x-3">
          <HiPlus className="text-xl" />
          New Deal
        </div>
      </Button>
      <Button color="gray" onClick={handleDealDataExport}>
        <div className="flex items-center gap-x-3">
          <HiDocumentDownload className="text-xl" />
          <span>Export</span>
        </div>
      </Button>
      <ImportDealsModal onUpdate={onUpdate} />
      <Modal size="xl" onClose={() => setOpen(false)} show={isOpen} dismissible>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Add New Deal</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="flex flex-col">
              <Label htmlFor="dealName" className="mb-1 text-sm">Deal Name <span className="text-red-500">*</span></Label>
              <TextInput
                id="dealName"
                name="dealName"
                placeholder="Deal Name"
                value={formData.dealName}
                onChange={handleChange}
                sizing="sm"
              />
            </div>

            {/* Created By - Auto-filled from logged in user */}
            <div className="flex flex-col">
              <Label htmlFor="createdBy" className="mb-1 text-sm">Created By</Label>
              <div className="flex items-center px-2.5 py-1.5 text-sm text-gray-700 bg-gray-50 border border-gray-300 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300">
                <span className="font-medium">
                  {`${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || 'Current User'}
                </span>
              </div>
            </div>

            {/* Company Dropdown */}
            <div className="flex flex-col sm:col-span-2">
              <Label htmlFor="companyId" className="mb-1 text-sm">Company <span className="text-red-500">*</span></Label>
              <Select
                name="companyId"
                options={companyOptions}
                value={companyOptions.find((opt: any) => opt.value === formData.companyId)}
                onChange={(selectedOption) =>
                  setFormData((prev: any) => ({
                    ...prev,
                    companyId: selectedOption?.value || "",
                  }))
                }
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'white',
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    borderWidth: '1px',
                    borderRadius: '0.375rem',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6'
                    }
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                    color: state.isSelected ? 'white' : '#374151',
                    '&:hover': {
                      backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  })
                }}
              />
            </div>

            {/* Amount */}
            <div className="flex flex-col">
              <Label htmlFor="amount" className="mb-1 text-sm">Amount <span className="text-red-500">*</span></Label>
              <TextInput
                id="amount"
                name="amount"
                type="number"
                min="0"
                step="0.01"
                placeholder="0.00"
                value={formData.amount}
                onChange={handleChange}
                sizing="sm"
              />
            </div>

            {/* Expected Closing Date */}
            <div className="flex flex-col">
              <Label htmlFor="expectedClosingDate" className="mb-1 text-sm">Expected Closing Date <span className="text-red-500">*</span></Label>
              <TextInput
                id="expectedClosingDate"
                name="expectedClosingDate"
                type="date"
                value={formData.expectedClosingDate}
                onChange={handleChange}
                sizing="sm"
              />
            </div>

              </div>
            </div>

            {/* Contacts & Tags Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contacts & Tags</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {/* Contact Multi-select */}
            <div className="flex flex-col sm:col-span-2">
              <Label htmlFor="contactIds" className="mb-1 text-sm">Contacts</Label>
              <Select
                isMulti
                name="contactIds"
                options={contacts.map((contact: any) => ({
                  value: contact.id,
                  label: `${contact.firstName} ${contact.lastName}`,
                }))}
                value={contacts
                  .filter((c: any) => formData.contactIds.includes(c.id))
                  .map((c: any) => ({
                    value: c.id,
                    label: `${c.firstName} ${c.lastName}`,
                  }))}
                onChange={(selectedOptions) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    contactIds: selectedOptions.map((opt) => opt.value),
                  }));
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'white',
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    borderWidth: '1px',
                    borderRadius: '0.375rem',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6'
                    }
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                    color: state.isSelected ? 'white' : '#374151',
                    '&:hover': {
                      backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: '#e5e7eb',
                    borderRadius: '0.25rem'
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: '#374151'
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: '#6b7280',
                    '&:hover': {
                      backgroundColor: '#d1d5db',
                      color: '#374151'
                    }
                  })
                }}
              />
            </div>

            {/* Stage */}
            <div className="flex flex-col">
              <Label htmlFor="stage" className="mb-1 text-sm">Stage</Label>
              <Select
                name="stage"
                options={stageOptions}
                value={stageOptions.find((opt) => opt.value === formData.stage)}
                onChange={(selectedOption) =>
                  setFormData((prev: any) => ({
                    ...prev,
                    stage: selectedOption?.value || "",
                  }))
                }
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'white',
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    borderWidth: '1px',
                    borderRadius: '0.375rem',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6'
                    }
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                    color: state.isSelected ? 'white' : '#374151',
                    '&:hover': {
                      backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  })
                }}
              />
            </div>

            {/* Tags */}
            <div className="flex flex-col sm:col-span-2">
              <Label htmlFor="tags" className="mb-1 text-sm">Tags</Label>
              <CreatableSelect
                isMulti
                name="tags"
                options={tagOptions}
                value={formData.tags.map((tag: string) => tagOptions.find((opt) => opt.value === tag)).filter(Boolean)}
                onChange={handleTagsChange}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select or create tags..."
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'white',
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    borderWidth: '1px',
                    borderRadius: '0.375rem',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6'
                    }
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                    color: state.isSelected ? 'white' : '#374151',
                    '&:hover': {
                      backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    borderRadius: '0.25rem',
                    padding: '2px 6px',
                    margin: '2px'
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: 'white',
                    fontWeight: '500'
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#ef4444',
                      color: 'white'
                    }
                  })
                }}
              />
            </div>

              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Additional Information</h3>
              <div className="space-y-3">
            {/* Description */}
            <div className="flex flex-col">
              <Label htmlFor="description" className="mb-1 text-sm">Description</Label>
              <textarea
                id="description"
                name="description"
                placeholder="Enter deal description"
                value={formData.description}
                onChange={handleTextareaChange}
                className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                rows={3}
              />
            </div>

            {/* Remark */}
            <div className="flex flex-col">
              <Label htmlFor="remark" className="mb-1 text-sm">Remark</Label>
              <textarea
                id="remark"
                name="remark"
                placeholder="Add a remark about this deal..."
                value={formData.remark}
                onChange={handleTextareaChange}
                className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                rows={3}
              />
            </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleAddDeal} disabled={loading}>
              {loading ? "Adding..." : "Add Deal"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>


    </>
  );
};




// { searchTerm, filters } as prop later use
export const AllDealsTable: FC<any> = ({ paginatedDeals, searchTerm }) => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { deals, setDeals } = useAppContext();
  const [userCache, setUserCache] = useState<{ [key: number]: string }>({});
  const [expandedDeals, setExpandedDeals] = useState<Set<number>>(new Set());
  const [expandedTags, setExpandedTags] = useState<Set<number>>(new Set());
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false; };
  }, []);

  const getUserName = async (deal: any) => {
    if (!deal.userId) return 'Unknown User';
    const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
    if (currentUser.id === deal.userId || currentUser._id === deal.userId) {
      return `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.email || 'Current User';
    }
    if (userCache[deal.userId]) return userCache[deal.userId];
    try {
      const userService = new (await import("../services/user")).User("/users");
      const response = await userService.getUserById(deal.userId.toString());
      const user = response.data;
      const name = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || `User ID: ${deal.userId}`;
      if (isMounted.current) setUserCache((prev) => ({ ...prev, [deal.userId]: name }));
      return name;
    } catch {
      return `User ID: ${deal.userId}`;
    }
  };

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const response = await dealService.listDeals();
        setDeals(response.data.deals);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch deals", error);
      }
    };

    fetchDeals();
  }, []);
  const excludedColumns = ['id', 'accountManagerId', 'companyId', 'createdAt', 'updatedAt', 'userId', 'unstructuredData'];
  
  // Standard columns to show in order
  const standardColumns = [
    'dealName',
    'company',
    'amount',
    'expectedClosingDate',
    'stage',
    'description',
    'tags',
    'remark',
    'contacts'
  ];

  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await dealService.listDeals();
      const sorted = response.data.deals.sort((a: any, b: any) => a.id - b.id);
      setDeals(sorted);
    } catch (error) {
      console.error("Failed to refresh deals", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllUserNames = async () => {
      for (const deal of paginatedDeals) {
        if (deal.userId && !userCache[deal.userId]) {
          const name = await getUserName(deal);
          if (isMounted.current) setUserCache((prev) => ({ ...prev, [deal.userId]: name }));
        }
      }
    };
    fetchAllUserNames();
    // eslint-disable-next-line
  }, [paginatedDeals]);

  // Inline Editable Stage Component
  const InlineStageEditor: FC<{ stage: string; dealId: number; onUpdate: () => void }> = ({ stage, dealId, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [currentStage, setCurrentStage] = useState(stage);

    const getStageClasses = (stageValue: string) => {
      return stageValue === "Opportunity" ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" :
        stageValue === "Proposal Sent" ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300" :
          stageValue === "In Negotiation" ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" :
            stageValue === "Won" ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" :
              stageValue === "Lost" ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" :
                stageValue === "Delayed" ? "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300" :
                  "bg-gray-200 text-gray-900 dark:bg-gray-700 dark:text-white";
    };

    const handleStageChange = async (newStage: string) => {
      if (newStage === currentStage) {
        setIsEditing(false);
        return;
      }
      try {
        setUpdating(true);
        await dealService.updateDeal(dealId, { stage: newStage });
        setCurrentStage(newStage);
        setIsEditing(false);
        onUpdate();
        toast.success("Stage updated successfully!");
      } catch (error) {
        console.error("Failed to update stage", error);
        toast.error("Failed to update stage");
      } finally {
        setUpdating(false);
      }
    };

    useEffect(() => {
      setCurrentStage(stage);
    }, [stage]);

    if (isEditing) {
      return (
        <select
          value={currentStage}
          onChange={(e) => handleStageChange(e.target.value)}
          onBlur={() => setIsEditing(false)}
          autoFocus
          disabled={updating}
          className={`text-xs font-medium px-2.5 py-0.5 rounded-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 ${getStageClasses(currentStage)}`}
          onClick={(e) => e.stopPropagation()}
        >
          <option value="Opportunity">Opportunity</option>
          <option value="Proposal Sent">Proposal Sent</option>
          <option value="In Negotiation">In Negotiation</option>
          <option value="Won">Won</option>
          <option value="Lost">Lost</option>
          <option value="Delayed">Delayed</option>
        </select>
      );
    }

    return (
      <span
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
        className={`text-xs font-medium px-2.5 py-0.5 rounded-sm cursor-pointer hover:opacity-80 transition-opacity ${getStageClasses(currentStage)}`}
        title="Click to change stage"
      >
        {currentStage}
      </span>
    );
  };

  return (
    <div>

      <Table className="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
        <Table.Head className="bg-gray-100 dark:bg-gray-700">
          <Table.HeadCell className="capitalize">SNO</Table.HeadCell>
          {standardColumns.map((key) => (
            <Table.HeadCell key={key} className="capitalize">
              {key.replace(/([A-Z])/g, " $1").replace(/^\w/, c => c.toUpperCase())}
            </Table.HeadCell>
          ))}
          <Table.HeadCell className="capitalize">Unstructured Data</Table.HeadCell>
          <Table.HeadCell className="capitalize">Account Manager</Table.HeadCell>
          <Table.HeadCell>Actions</Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800 cursor-pointer">
          {loading ? (
            <Table.Row>
              <Table.Cell colSpan={standardColumns.length + 4} className="text-center p-4">
                <div className="flex justify-center items-center">
                  <FadeLoader color="#3f83f8" />
                </div>
              </Table.Cell>
            </Table.Row>
          ) : paginatedDeals.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan={standardColumns.length + 4} className="text-center p-4">
                <p className="text-lg text-gray-600 dark:text-gray-300">No deals found.</p>
                <img
                  className="w-16 h-16 mt-4 relative left-[48%]"
                  src="https://cdn-icons-png.flaticon.com/128/921/921347.png"
                  alt="members"
                />
              </Table.Cell>
            </Table.Row>
          ) : (
            paginatedDeals.map((deal: any, index: number) => (
              <Table.Row
                key={deal.id}
                // onClick={() => navigate(`/pages/deals/${deal.id}`)}
                className="hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                <Table.Cell className="whitespace-nowrap p-4 text-sm text-gray-900 dark:text-white">
                  {index + 1}
                </Table.Cell>
                {standardColumns.map((key) => {
                  const value = deal[key];
                  return (
                    <Table.Cell
                      key={key}
                      className="whitespace-nowrap p-4 text-sm text-gray-900 dark:text-white"
                    >
                      {key === "company" && value && typeof value === "object" ? (
                        value.name || "-"
                      ) : key === "contacts" && Array.isArray(value) ? (
                        value.length > 0 ? (
                          value
                            .map(
                              (contact: any) =>
                                `${contact.pronoun || ''} ${contact.firstName || ''} ${contact.lastName || ''}`.trim()
                            )
                            .filter(Boolean)
                            .join(", ") || "-"
                        ) : "-"
                      ) : key === "expectedClosingDate" && value ? (
                        new Date(value).toLocaleDateString(undefined, {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      ) : key === "stage" && value ? (
                        <InlineStageEditor stage={value} dealId={deal.id} onUpdate={onUpdate} />
                      ) : key === "tags" ? (
                        <div className="flex flex-wrap gap-1 items-center">
                          {Array.isArray(value) && value.length > 0 ? (
                            <>
                              {(expandedTags.has(deal.id) 
                                ? value 
                                : value.slice(0, 2)
                              ).map((tag: string, index: number) => (
                                <span
                                  key={index}
                                  className={`text-xs font-medium px-2 py-0.5 rounded-sm
                                    ${tag === "todo" ? "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300" :
                                      tag === "in-progress" ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" :
                                        tag === "done" ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" :
                                          tag === "closed" ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" :
                                            "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300"}
                                  `}
                                >
                                  {tag.charAt(0).toUpperCase() + tag.slice(1).replace('-', ' ')}
                                </span>
                              ))}
                              {value.length > 2 && (
                                <button
                                  onClick={() => {
                                    setExpandedTags(prev => {
                                      const newSet = new Set(prev);
                                      if (newSet.has(deal.id)) {
                                        newSet.delete(deal.id);
                                      } else {
                                        newSet.add(deal.id);
                                      }
                                      return newSet;
                                    });
                                  }}
                                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-xs font-medium cursor-pointer underline"
                                >
                                  {expandedTags.has(deal.id) 
                                    ? "Show less" 
                                    : `+${value.length - 2} more`
                                  }
                                </button>
                              )}
                            </>
                          ) : (
                            <span className="text-xs text-gray-400">-</span>
                          )}
                        </div>
                      ) : key === "remark" ? (
                        <div className="max-w-xs">
                          {value ? (
                            <div className="text-sm text-gray-600 dark:text-gray-400">
                              {(() => {
                                const remarks = value.split('\n\n');
                                const firstRemark = remarks[0];
                                const parts = firstRemark.split(': ');
                                const content = parts.slice(1).join(': ');
                                
                                if (!content || content.trim() === '') {
                                  return firstRemark.length > 50 ? `${firstRemark.substring(0, 50)}...` : firstRemark;
                                }
                                
                                return content.length > 50 ? `${content.substring(0, 50)}...` : content;
                              })()}
                            </div>
                          ) : (
                            <span className="text-gray-400 dark:text-gray-500">-</span>
                          )}
                        </div>
                      ) : key === "amount" && value ? (
                        `$${Number(value).toLocaleString()}`
                      ) : key === "description" && value ? (
                        <div className="max-w-xs truncate" title={value}>
                          {value.length > 50 ? `${value.substring(0, 50)}...` : value}
                        </div>
                      ) : value !== null && value !== undefined && value !== "" ? (
                        String(value)
                      ) : (
                        <span className="text-gray-400 dark:text-gray-500">-</span>
                      )}
                    </Table.Cell>
                  );
                })}
                {/* Unstructured Data Column */}
                <Table.Cell className="p-4 text-sm text-gray-900 dark:text-white">
                  {deal.unstructuredData && typeof deal.unstructuredData === 'object' && Object.keys(deal.unstructuredData).length > 0 ? (
                    <div className="max-w-xs">
                      <div className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                        {(expandedDeals.has(deal.id) 
                          ? Object.entries(deal.unstructuredData) 
                          : Object.entries(deal.unstructuredData).slice(0, 5)
                        ).map(([k, v]: [string, any]) => (
                          <div key={k} className="truncate" title={`${k}: ${v}`}>
                            <span className="font-semibold text-gray-700 dark:text-gray-300">{k}:</span>{" "}
                            <span className="text-gray-600 dark:text-gray-400">
                              {v !== null && v !== undefined && v !== "" ? String(v) : "-"}
                            </span>
                          </div>
                        ))}
                        {Object.keys(deal.unstructuredData).length > 5 && (
                          <button
                            onClick={() => {
                              setExpandedDeals(prev => {
                                const newSet = new Set(prev);
                                if (newSet.has(deal.id)) {
                                  newSet.delete(deal.id);
                                } else {
                                  newSet.add(deal.id);
                                }
                                return newSet;
                              });
                            }}
                            className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-xs mt-1 font-medium cursor-pointer underline"
                          >
                            {expandedDeals.has(deal.id) 
                              ? "Show less" 
                              : `+${Object.keys(deal.unstructuredData).length - 5} more fields`
                            }
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <span className="text-gray-400 dark:text-gray-500">-</span>
                  )}
                </Table.Cell>

                {/* Account Manager Column */}
                <Table.Cell className="whitespace-nowrap p-4 text-sm text-gray-900 dark:text-white">
                  {(() => {
                    const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
                    if (deal.user && typeof deal.user === 'object') {
                      return `${deal.user.firstName || ''} ${deal.user.lastName || ''}`.trim() || deal.user.email || 'Unknown User';
                    } else if (deal.userId && (currentUser.id === deal.userId || currentUser._id === deal.userId)) {
                      return `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.email || 'Unknown User';
                    } else {
                      return 'Unknown User';
                    }
                  })()}
                </Table.Cell>

                <Table.Cell className="whitespace-nowrap p-4">
                  <div className="flex items-center gap-x-3">
                    <DealDetailModal deal={deal} onUpdate={onUpdate} />
                    <DeleteDealModal deal={deal} onUpdate={onUpdate} />
                    <EditDealModal deal={deal} onUpdate={onUpdate} />
                  </div>
                </Table.Cell>
              </Table.Row>
            ))
          )}
        </Table.Body>
      </Table>

    </div>


  );
};

export const EditDealModal: FC<{ deal: any; onUpdate: () => void }> = ({
  deal,
  onUpdate,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { companies, contacts, deals } = useAppContext();
  const companyOptions = companies.map((company: any) => ({
    value: company.id,
    label: company.name,
  }));

  const contactOptions = contacts.map((contact: any) => ({
    value: contact.id,
    label: `${contact.firstName} ${contact.lastName}`,
  }));
  const stageOptions = [
    "Opportunity",
    "Proposal Sent",
    "In Negotiation",
    "Won",
    "Lost",
    "Delayed",
  ].map((stage) => ({
    value: stage,
    label: stage,
  }));

  const tagOptions = generateTagOptions(deals);

  // Convert unstructuredData object to array of {key, value} for editing
  const unstructuredToArr = (obj: any) =>
    obj && typeof obj === "object" && !Array.isArray(obj)
      ? Object.entries(obj).map(([key, value]) => ({ key, value: String(value ?? "") }))
      : [];

  const [formData, setFormData] = useState({
    dealName: deal.dealName || "",
    description: deal.description || "",
    companyId: deal.companyId ? String(deal.companyId) : "",
    amount: deal.amount ? String(deal.amount) : "",
    expectedClosingDate: deal.expectedClosingDate
      ? new Date(deal.expectedClosingDate).toISOString().split("T")[0]
      : "",
    stage: deal.stage || "Opportunity",
    tags: Array.isArray(deal.tags) ? deal.tags : [],
    remark: deal.remark || "",
    contactIds: Array.isArray(deal.contactIds) ? deal.contactIds : [],
    unstructuredData: unstructuredToArr(deal.unstructuredData),
  }) as any;

  useEffect(() => {
    setFormData({
      dealName: deal.dealName || "",
      description: deal.description || "",
      companyId: deal.companyId ? String(deal.companyId) : "",
      amount: deal.amount ? String(deal.amount) : "",
      expectedClosingDate: deal.expectedClosingDate
        ? new Date(deal.expectedClosingDate).toISOString().split("T")[0]
        : "",
      stage: deal.stage || "Opportunity",
      tags: Array.isArray(deal.tags) ? deal.tags : [],
      remark: deal.remark || "",
      contactIds: Array.isArray(deal.contacts)
        ? deal.contacts.map((c: any) => c.id)
        : [],
      unstructuredData: unstructuredToArr(deal.unstructuredData),
    });
  }, [deal]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    if (name === "contactIds") {
      // For multi-select, value is handled differently below
      return;
    }

    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContactsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((opt) =>
      Number(opt.value)
    );
    setFormData((prev: any) => ({
      ...prev,
      contactIds: selectedOptions,
    }));
  };

  const handleTagsChange = (selectedOptions: any) => {
    const newTags = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
    setFormData((prev: any) => ({
      ...prev,
      tags: newTags,
    }));
  };

  const handleUnstructuredChange = (index: number, field: "key" | "value", val: string) => {
    setFormData((prev: any) => ({
      ...prev,
      unstructuredData: prev.unstructuredData.map((item: any, i: number) =>
        i === index ? { ...item, [field]: val } : item
      ),
    }));
  };

  const handleAddUnstructuredField = () => {
    setFormData((prev: any) => ({
      ...prev,
      unstructuredData: [...(prev.unstructuredData || []), { key: "", value: "" }],
    }));
  };

  const handleRemoveUnstructuredField = (index: number) => {
    setFormData((prev: any) => ({
      ...prev,
      unstructuredData: prev.unstructuredData.filter((_: any, i: number) => i !== index),
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const unstructuredObj: Record<string, string> = {};
      (formData.unstructuredData || []).forEach((item: { key: string; value: string }) => {
        if (item.key?.trim()) {
          unstructuredObj[item.key.trim()] = item.value ?? "";
        }
      });

      const payload = {
        dealName: formData.dealName,
        description: formData.description,
        companyId: Number(formData.companyId),
        amount: parseFloat(formData.amount),
        expectedClosingDate: new Date(formData.expectedClosingDate).toISOString(),
        stage: formData.stage,
        tags: formData.tags,
        remark: formData.remark,
        contactIds: formData.contactIds,
        unstructuredData: unstructuredObj,
      };
      await dealService.updateDeal(deal.id, payload);
      setOpen(false);
      onUpdate();
    } catch (error) {
      console.error("Failed to update deal", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        color="primary"
        onClick={(e: any) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <div className="flex items-center gap-x-2">
          <HiOutlinePencilAlt className="text-lg" />
          Edit
        </div>
      </Button>

      <Modal
        size="xl"
        onClick={(e) => e.stopPropagation()}
        onClose={() => setOpen(false)}
        show={isOpen}
        dismissible
      >
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Edit Deal</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label htmlFor="dealName" className="mb-1 text-sm">Deal Name <span className="text-red-500">*</span></Label>
                  <TextInput
                    id="dealName"
                    name="dealName"
                    placeholder="Enter deal name"
                    value={formData.dealName}
                    onChange={handleChange}
                    required
                    sizing="sm"
                  />
                </div>

                <div className="flex flex-col sm:col-span-2">
                  <Label htmlFor="companyId" className="mb-1 text-sm">Company <span className="text-red-500">*</span></Label>
                  <Select
                    name="companyId"
                    options={companyOptions}
                    value={companyOptions.find((opt: any) => opt.value === Number(formData.companyId))}
                    onChange={(selectedOption) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        companyId: selectedOption?.value || "",
                      }))
                    }
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'white',
                        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                        borderWidth: '1px',
                        borderRadius: '0.375rem',
                        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                        '&:hover': {
                          borderColor: '#3b82f6'
                        }
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                        color: state.isSelected ? 'white' : '#374151',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                        }
                      }),
                      menu: (provided) => ({
                        ...provided,
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      })
                    }}
                  />
                </div>

                <div className="flex flex-col">
                  <Label htmlFor="stage" className="mb-1 text-sm">Stage</Label>
                  <Select
                    name="stage"
                    options={stageOptions}
                    value={stageOptions.find((opt) => opt.value === formData.stage)}
                    onChange={(selectedOption) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        stage: selectedOption?.value || "",
                      }))
                    }
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'white',
                        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                        borderWidth: '1px',
                        borderRadius: '0.375rem',
                        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                        '&:hover': {
                          borderColor: '#3b82f6'
                        }
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                        color: state.isSelected ? 'white' : '#374151',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                        }
                      }),
                      menu: (provided) => ({
                        ...provided,
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      })
                    }}
                  />
                </div>
              </div>

              {/* Description */}
              <div className="mt-4">
                <Label htmlFor="description">Description</Label>
                <textarea
                  id="description"
                  name="description"
                  rows={3}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  placeholder="Enter deal description"
                  value={formData.description}
                  onChange={handleTextareaChange}
                />
              </div>
            </div>

            {/* Deal Details Section */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">Deal Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="flex flex-col">
                  <Label htmlFor="amount">Amount</Label>
                  <TextInput
                    id="amount"
                    name="amount"
                    type="number"
                    placeholder="0.00"
                    value={formData.amount}
                    onChange={handleChange}
                  />
                </div>

                <div className="flex flex-col">
                  <Label htmlFor="expectedClosingDate">Expected Closing Date</Label>
                  <TextInput
                    id="expectedClosingDate"
                    name="expectedClosingDate"
                    type="date"
                    value={formData.expectedClosingDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Contacts & Tags Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contacts & Tags</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label htmlFor="contactIds" className="mb-1 text-sm">Contacts</Label>
                  <Select
                    isMulti
                    name="contactIds"
                    options={contactOptions}
                    value={contactOptions.filter((opt: any) =>
                      formData.contactIds.map(Number).includes(opt.value)
                    )}
                    onChange={(selectedOptions) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        contactIds: selectedOptions.map((opt) => opt.value),
                      }))
                    }
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    backgroundColor: 'white',
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    borderWidth: '1px',
                    borderRadius: '0.375rem',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6'
                    }
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                    color: state.isSelected ? 'white' : '#374151',
                    '&:hover': {
                      backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                    }
                  }),
                  menu: (provided) => ({
                    ...provided,
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: '#e5e7eb',
                    borderRadius: '0.25rem'
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: '#374151'
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: '#6b7280',
                    '&:hover': {
                      backgroundColor: '#d1d5db',
                      color: '#374151'
                    }
                  })
                }}
              />
                </div>
              </div>

              {/* Description */}
              <div className="mt-4">
                <Label htmlFor="description">Description</Label>
                <textarea
                  id="description"
                  name="description"
                  rows={3}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  placeholder="Enter deal description"
                  value={formData.description}
                  onChange={handleTextareaChange}
                />
              </div>
            </div>

            {/* Deal Details Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Deal Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label htmlFor="amount" className="mb-1 text-sm">Amount</Label>
                  <TextInput
                    id="amount"
                    name="amount"
                    type="number"
                    placeholder="0.00"
                    value={formData.amount}
                    onChange={handleChange}
                    sizing="sm"
                  />
                </div>

                <div className="flex flex-col">
                  <Label htmlFor="expectedClosingDate" className="mb-1 text-sm">Expected Closing Date</Label>
                  <TextInput
                    id="expectedClosingDate"
                    name="expectedClosingDate"
                    type="date"
                    value={formData.expectedClosingDate}
                    onChange={handleChange}
                    sizing="sm"
                  />
                </div>
              </div>
            </div>

            {/* Contacts & Tags Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contacts & Tags</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label htmlFor="contactIds" className="mb-1 text-sm">Contacts</Label>
                  <Select
                    isMulti
                    name="contactIds"
                    options={contactOptions}
                    value={contactOptions.filter((opt: any) =>
                      formData.contactIds.map(Number).includes(opt.value)
                    )}
                    onChange={(selectedOptions) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        contactIds: selectedOptions.map((opt) => opt.value),
                      }))
                    }
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'white',
                        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                        borderWidth: '1px',
                        borderRadius: '0.375rem',
                        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                        '&:hover': {
                          borderColor: '#3b82f6'
                        }
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                        color: state.isSelected ? 'white' : '#374151',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                        }
                      }),
                      menu: (provided) => ({
                        ...provided,
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: '#e5e7eb',
                        borderRadius: '0.25rem'
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: '#374151'
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: '#6b7280',
                        '&:hover': {
                          backgroundColor: '#d1d5db',
                          color: '#374151'
                        }
                      })
                    }}
                  />
                </div>

                <div className="flex flex-col">
                  <Label htmlFor="tags" className="mb-1 text-sm">Tags</Label>
                  <Select
                    isMulti
                    name="tags"
                    options={tagOptions}
                    value={tagOptions.filter((opt: any) =>
                      formData.tags.includes(opt.value)
                    )}
                    onChange={handleTagsChange}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'white',
                        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                        borderWidth: '1px',
                        borderRadius: '0.375rem',
                        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                        '&:hover': {
                          borderColor: '#3b82f6'
                        }
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                        color: state.isSelected ? 'white' : '#374151',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6'
                        }
                      }),
                      menu: (provided) => ({
                        ...provided,
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: '#3b82f6',
                        borderRadius: '0.25rem'
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: 'white',
                        fontWeight: '500'
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#ef4444',
                          color: 'white'
                        }
                      })
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Additional Information</h3>
              <div className="space-y-3">
                <div className="flex flex-col">
                  <Label htmlFor="remark" className="mb-1 text-sm">Remark</Label>
                  <textarea
                    id="remark"
                    name="remark"
                    placeholder="Add a remark about this deal..."
                    value={formData.remark}
                    onChange={handleTextareaChange}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                    rows={3}
                  />
                </div>
              </div>
            </div>

            {/* Unstructured Data Section */}
            <div>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base font-semibold text-gray-900 dark:text-white">Custom Fields (Unstructured Data)</h3>
                <Button color="light" size="xs" onClick={handleAddUnstructuredField}>
                  <HiPlus className="text-sm mr-1" />
                  Add Field
                </Button>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
                Add custom key-value pairs (e.g. productCategory, leadSource, priority). These are searchable.
              </p>
              <div className="space-y-2">
                {(formData.unstructuredData || []).map((item: { key: string; value: string }, index: number) => (
                  <div key={index} className="flex gap-2 items-center">
                    <TextInput
                      placeholder="Key (e.g. productCategory)"
                      value={item.key}
                      onChange={(e) => handleUnstructuredChange(index, "key", e.target.value)}
                      sizing="sm"
                      className="flex-1 min-w-0"
                    />
                    <TextInput
                      placeholder="Value"
                      value={item.value}
                      onChange={(e) => handleUnstructuredChange(index, "value", e.target.value)}
                      sizing="sm"
                      className="flex-1 min-w-0"
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveUnstructuredField(index)}
                      className="p-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                      title="Remove field"
                    >
                      <HiTrash className="text-sm" />
                    </button>
                  </div>
                ))}
                {(!formData.unstructuredData || formData.unstructuredData.length === 0) && (
                  <div className="text-sm text-gray-500 dark:text-gray-400 py-2 border border-dashed border-gray-300 dark:border-gray-600 rounded-lg text-center">
                    No custom fields. Click &quot;Add Field&quot; to add.
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSave} disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
const EditActiveStateModal: FC<{ user: any }> = ({ user }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const { dummy, setDummy } = useAppContext();

  // Initial empty form data
  const [formData, setFormData] = useState({
    startDate: "",
    plan: "",
    isPaid: "",
    paidMonths: "",
  });
  const [plans, setPlans] = useState<{ _id: string; name: string }[]>([]);
  const owner = sessionStorage.getItem("user");
  if (!owner) {
    toast.error("Owner not found in session storage.");
    return;
  }

  const parsedUser = JSON.parse(owner);
  const ownerId = parsedUser._id;
  // useEffect(() => {
  //   const fetchPlans = async () => {
  //     try {
  //       const response = await planService.getPlanOByOwnerId(ownerId);
  //       setPlans(response.data.data);
  //     } catch (error) {
  //       toast.error("Failed to load plans.");
  //     }
  //   };

  //   fetchPlans();
  // }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };
  // const handleToggleActiveState = async (
  //   event: React.MouseEvent,
  //   member: any
  // ) => {
  //   event.stopPropagation();
  //   try {
  //     const updatedStatus = !member.active; // Toggle the current active state
  //     const data = { active: updatedStatus };

  //     // Call the update API
  //     await memberService.updateMember(member._id, data);
  //     setDummy(!dummy)
  //     toast.success("Active status updated successfully");
  //   } catch (error: any) {
  //     toast.error(
  //       error?.response?.data?.message || "Failed to update active status."
  //     );
  //   }
  // };
  // const openModal = (e: any, member: any) => {
  //   if (!member.active) {
  //     // setFormData({
  //     //   startDate: user.startDate
  //     //     ? format(new Date(user.startDate), "yyyy-MM-dd")
  //     //     : "",
  //     //   plan: user.plan?._id || "",
  //     //   isPaid: user.isPaid || "",
  //     //   paidMonths: user.paidMonths || "",
  //     // });
  //     setOpen(true);
  //   } else {
  //     handleToggleActiveState(e, member);
  //   }
  // };
  const handleDateChange = (date: Date | null, field: string) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: date ? format(date, "dd/MM/yyyy") : "",
    }));
  };
  // const handleSaveChanges = async () => {
  //   try {
  //     const formattedData = {
  //       ...formData,
  //       startDate: formData.startDate
  //         ? format(parse(formData.startDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
  //         : null,
  //       active: true,
  //       paidMonths: Number(formData.paidMonths) + 1
  //     };
  //     setLoading(true);

  //     // Call the update API
  //     await memberService.updateMember(user._id, formattedData);

  //     setDummy(!dummy);
  //     setOpen(false);
  //     toast.success("Active status updated successfully");
  //   } catch (error: any) {
  //     console.error("Error while updating active status", error);
  //     toast.error(
  //       error?.response?.data?.message || "Failed to update active status."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <>
      <Button
        color={user.active ? "success" : "failure"}
        onClick={(e: any) => { e.stopPropagation() }}
      >
        <div className="flex items-center gap-x-2">
          {user.active ? (
            <HiCheckCircle className="text-lg " />
          ) : (
            <HiXCircle className="text-lg" />
          )}
          {user.active ? "Deactivate" : "Activate"}
        </div>
      </Button>
      <Modal
        size={"2xl"}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        onClose={() => setOpen(false)}
        show={isOpen}
      >
        <Modal.Header className="border-b border-gray-200 !p-6 dark:border-gray-700">
          <strong>Change Status</strong>
        </Modal.Header>
        <Modal.Body>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">

            {/* Date Fields with DatePicker */}
            <div className="w-full">
              <label htmlFor="startDate">
                Start Date <span className="text-red-500">*</span>
              </label>
              <div className="mt-1 w-full">
                <DatePicker
                  id="startDate"
                  selected={
                    formData.startDate
                      ? new Date(
                        formData.startDate.split("/").reverse().join("-")
                      )
                      : null
                  }
                  className="mt-1 p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm w-full"
                  onChange={(date) => handleDateChange(date, "startDate")}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select Start Date"
                />
              </div>
            </div>


            <div>
              <Label htmlFor="plan">Plan</Label>
              <select
                id="plan"
                name="plan"
                value={formData.plan}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select Plan</option>
                {plans.map((plan: any) => (
                  <option key={plan._id} value={plan._id}>
                    {plan.planName}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label htmlFor="isPaid">Paid Status</Label>
              <select
                id="isPaid"
                name="isPaid"
                value={formData.isPaid}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div>
              <Label htmlFor="paidMonths">Number of Paid Months</Label>
              <TextInput
                id="paidMonths"
                placeholder="eg. 2"
                name="paidMonths"
                type={formData.isPaid === "true" ? "number" : "text"}
                value={formData.paidMonths}
                onChange={handleChange}
                disabled={formData.isPaid !== "true"}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="primary"
            className="flex justify-center items-center"
            onClick={() => { }}
            disabled={loading}
          >
            <HiSave className="text-xl mr-2" />
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


const DeleteDealModal: FC<{ deal: any; onUpdate: () => void }> = ({ deal, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await dealService.deleteDeal(deal.id);
      setOpen(false);
      onUpdate(); // refresh list
    } catch (error) {
      console.error("Delete failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button color="failure" onClick={(e: any) => {
        e.stopPropagation();
        setOpen(true);
      }}>
        <div className="flex items-center gap-x-2">
          <HiTrash className="text-lg" />
          Delete
        </div>
      </Button>

      <Modal onClose={() => setOpen(false)} show={isOpen} size="md" dismissible>
        <Modal.Header className="px-6 pb-0 pt-6">
          <span className="sr-only">Delete deal</span>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-0">
          <div className="flex flex-col items-center gap-y-6 text-center">
            <HiOutlineExclamationCircle className="text-7xl text-red-500" />
            <p className="text-xl text-gray-500">
              Are you sure you want to delete this deal?
            </p>
            <div className="flex items-center gap-x-3">
              <Button color="failure" onClick={handleDelete} isProcessing={loading}>
                Yes, I'm sure
              </Button>
              <Button color="gray" onClick={(e: any) => { e.stopPropagation(); setOpen(false) }} disabled={loading}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  setCurrentPage: (page: number) => void;
}
export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  setCurrentPage,
}) => {
  return (
    <div className="sticky bottom-0 right-0 w-full items-center border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex sm:justify-between">
      <div className="mb-4 flex items-center sm:mb-0 space-x-2">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
          className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50"
        >
          <HiChevronLeft className="text-2xl" />
        </button>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
          className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50"
        >
          <HiChevronRight className="text-2xl" />
        </button>

        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
          Showing&nbsp;
          <span className="font-semibold text-gray-900 dark:text-white">
            {(currentPage - 1) * itemsPerPage + 1}-
            {Math.min(currentPage * itemsPerPage, totalItems)}
          </span>
          &nbsp;of&nbsp;
          <span className="font-semibold text-gray-900 dark:text-white">
            {totalItems}
          </span>
        </span>
      </div>

      <div className="flex items-center space-x-2 mt-2 sm:mt-0">
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`px-3 py-1 rounded text-sm ${currentPage === i + 1
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-white"
              }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

// Deal Detail Modal Component
export const DealDetailModal: FC<{ deal: any; onUpdate: () => void }> = ({
  deal,
  onUpdate,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [newRemark, setNewRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [creatorName, setCreatorName] = useState<string>("Loading...");
  const [editingRemarkIndex, setEditingRemarkIndex] = useState<number | null>(null);
  const [editingRemarkContent, setEditingRemarkContent] = useState("");
  const [newTag, setNewTag] = useState("");

  const handleAddRemark = async () => {
    if (!newRemark.trim()) return;
    
    try {
      setLoading(true);
      const currentDate = new Date().toLocaleDateString('en-US', { 
        month: '2-digit', 
        day: '2-digit', 
        year: 'numeric' 
      });
      
      const updatedRemark = deal.remark 
        ? `${deal.remark}\n\n${currentDate}: ${newRemark}`
        : `${currentDate}: ${newRemark}`;

      await dealService.updateDeal(deal.id, {
        ...deal,
        remark: updatedRemark,
      });
      
      setNewRemark("");
      onUpdate();
      toast.success("Remark added successfully!");
    } catch (error) {
      console.error("Failed to add remark", error);
      toast.error("Failed to add remark");
    } finally {
      setLoading(false);
    }
  };

  const handleEditRemark = (remarkIndex: number) => {
    const remarks = parseRemarks(deal.remark);
    setEditingRemarkIndex(remarkIndex);
    setEditingRemarkContent(remarks[remarkIndex].content);
  };

  const handleSaveEditRemark = async () => {
    if (editingRemarkIndex === null || !editingRemarkContent.trim()) return;
    
    try {
      setLoading(true);
      const remarks = deal.remark ? deal.remark.split('\n\n') : [];
      const remarkToEdit = remarks[editingRemarkIndex];
      const parts = remarkToEdit.split(': ');
      const date = parts[0];
      const updatedRemark = `${date}: ${editingRemarkContent}`;
      remarks[editingRemarkIndex] = updatedRemark;
      const updatedRemarkString = remarks.join('\n\n');

      await dealService.updateDeal(deal.id, {
        ...deal,
        remark: updatedRemarkString,
      });
      
      setEditingRemarkIndex(null);
      setEditingRemarkContent("");
      onUpdate();
      toast.success("Remark updated successfully!");
    } catch (error) {
      console.error("Failed to update remark", error);
      toast.error("Failed to update remark");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEditRemark = () => {
    setEditingRemarkIndex(null);
    setEditingRemarkContent("");
  };

  const handleDeleteRemark = async (remarkIndex: number) => {
    try {
      setLoading(true);
      const remarks = deal.remark ? deal.remark.split('\n\n') : [];
      remarks.splice(remarkIndex, 1);
      const updatedRemark = remarks.join('\n\n');

      await dealService.updateDeal(deal.id, {
        ...deal,
        remark: updatedRemark,
      });
      
      onUpdate();
      toast.success("Remark deleted successfully!");
    } catch (error) {
      console.error("Failed to delete remark", error);
      toast.error("Failed to delete remark");
    } finally {
      setLoading(false);
    }
  };

  const handleAddTag = async () => {
    if (!newTag.trim()) return;
    
    try {
      setLoading(true);
      const currentTags = Array.isArray(deal.tags) ? [...deal.tags] : [];
      const tagToAdd = newTag.trim().toLowerCase();
      
      if (currentTags.includes(tagToAdd)) {
        toast.error("Tag already exists!");
        setNewTag("");
        return;
      }
      
      currentTags.push(tagToAdd);

      await dealService.updateDeal(deal.id, {
        ...deal,
        tags: currentTags,
      });
      
      setNewTag("");
      onUpdate();
      toast.success("Tag added successfully!");
    } catch (error) {
      console.error("Failed to add tag", error);
      toast.error("Failed to add tag");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTag = async (tagToDelete: string) => {
    try {
      setLoading(true);
      const currentTags = Array.isArray(deal.tags) ? [...deal.tags] : [];
      const updatedTags = currentTags.filter(tag => tag !== tagToDelete);

      await dealService.updateDeal(deal.id, {
        ...deal,
        tags: updatedTags,
      });
      
      onUpdate();
      toast.success("Tag removed successfully!");
    } catch (error) {
      console.error("Failed to remove tag", error);
      toast.error("Failed to remove tag");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const isPastDue = (dateString: string) => {
    return new Date(dateString) < new Date();
  };

  // Parse remarks to get individual remark objects
  const parseRemarks = (remarkString: string) => {
    if (!remarkString) return [];
    
    return remarkString.split('\n\n').map((remark: string) => {
      const parts = remark.split(': ');
      const date = parts[0];
      const content = parts.slice(1).join(': ');
      
      // Handle edge cases where there might not be a proper date:content format
      if (!date || !content) {
        return { date: 'Unknown Date', content: remark };
      }
      
      return { date, content };
    }).filter(remark => remark.content.trim()); // Filter out empty remarks
  };

  const remarks = parseRemarks(deal.remark);

  // Fetch creator name when modal opens
  useEffect(() => {
    const fetchCreatorName = async () => {
      if (deal.userId && isOpen) {
        try {
          // Try to get user info from session storage first
          const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
          
          if (currentUser.id === deal.userId || currentUser._id === deal.userId) {
            const name = `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.email || 'Current User';
            setCreatorName(name);
            return;
          }
          
          // If not current user, try to fetch from API
          const userService = new (await import("../services/user")).User("/users");
          const response = await userService.getUserById(deal.userId.toString());
          const user = response.data;
          const name = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || `User ID: ${deal.userId}`;
          setCreatorName(name);
        } catch (error) {
          console.error("Failed to fetch creator name:", error);
          setCreatorName(`User ID: ${deal.userId}`);
        }
      } else if (!deal.userId) {
        // For existing deals without userId, show current user as fallback
        const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
        if (currentUser.firstName || currentUser.lastName || currentUser.email) {
          const name = `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.email || 'Current User';
          setCreatorName(name);
        } else {
          setCreatorName("Unknown User");
        }
      }
    };

    fetchCreatorName();
  }, [deal.userId, isOpen]);

  return (
    <>
      <Button
        color="gray"
        size="sm"
        onClick={() => setOpen(true)}
      >
        <HiDocumentText className="text-lg" />
      </Button>

      <Modal size="xl" onClose={() => setOpen(false)} show={isOpen} dismissible>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Deal Details</strong>
        </Modal.Header>
        
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Deal Name</Label>
                  <div className="text-sm text-gray-900 dark:text-white font-medium px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                    {deal.dealName}
                  </div>
                </div>

                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Company</Label>
                  <div className="text-sm text-gray-900 dark:text-white font-medium px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                    {deal.company?.name || "No company assigned"}
                  </div>
                </div>

                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Stage</Label>
                  <span
                    className={`text-xs font-medium px-3 py-1.5 rounded-full inline-block
                      ${deal.stage === "Opportunity" ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" :
                        deal.stage === "Proposal Sent" ? "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300" :
                          deal.stage === "In Negotiation" ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" :
                            deal.stage === "Won" ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" :
                              deal.stage === "Lost" ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" :
                                deal.stage === "Delayed" ? "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300" :
                                  "bg-gray-200 text-gray-900 dark:bg-gray-700 dark:text-white"}
                    `}
                  >
                    {deal.stage}
                  </span>
                </div>

                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Created By</Label>
                  <div className="text-sm text-gray-900 dark:text-white font-medium px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                    {creatorName}
                  </div>
                </div>
              </div>
            </div>

            {/* Deal Details Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Deal Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Expected Closing Date</Label>
                  <div className="flex items-center gap-2">
                    <div className="text-sm text-gray-900 dark:text-white font-medium px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                      {formatDate(deal.expectedClosingDate)}
                    </div>
                    {isPastDue(deal.expectedClosingDate) && (
                      <span className="text-xs bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300 px-2 py-1 rounded-full font-medium">
                        Past Due
                      </span>
                    )}
                  </div>
                </div>
                
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Amount</Label>
                  <div className="text-sm text-gray-900 dark:text-white font-medium px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                    ${deal.amount?.toLocaleString() || "0"}
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <Label className="mb-1 text-sm">Description</Label>
                <div className="text-sm text-gray-900 dark:text-white leading-relaxed px-2.5 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600 min-h-[60px]">
                  {deal.description || "No description provided."}
                </div>
              </div>
            </div>

            {/* Contacts & Tags Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Contacts & Tags</h3>
              <div className="space-y-3">
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Contacts</Label>
                  <div className="space-y-2">
                    {deal.contacts && deal.contacts.length > 0 ? (
                      deal.contacts.map((contact: any, index: number) => (
                        <div key={index} className="flex items-center gap-3 p-2 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                            <span className="text-white font-semibold text-xs">
                              {contact.firstName?.charAt(0)?.toUpperCase() || ""}{contact.lastName?.charAt(0)?.toUpperCase() || ""}
                            </span>
                          </div>
                          <div className="flex-1">
                            <div className="text-sm font-medium text-gray-900 dark:text-white">
                              {contact.firstName} {contact.lastName}
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-400">
                              {contact.title || "No title"} {deal.company?.name ? `at ${deal.company.name}` : ""}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-sm text-gray-500 dark:text-gray-400 px-2.5 py-1.5">No contacts assigned.</div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Tags</Label>
                  <div className="space-y-2">
                    <div className="flex flex-wrap gap-2">
                      {Array.isArray(deal.tags) && deal.tags.length > 0 ? (
                        deal.tags.map((tag: string, index: number) => (
                          <span
                            key={index}
                            className={`text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1
                              ${tag === "todo" ? "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300" :
                                tag === "in-progress" ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" :
                                  tag === "done" ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" :
                                    tag === "closed" ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" :
                                      "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300"}
                            `}
                          >
                            {tag.charAt(0).toUpperCase() + tag.slice(1).replace('-', ' ')}
                            <button
                              onClick={() => handleDeleteTag(tag)}
                              disabled={loading}
                              className="hover:text-red-600 dark:hover:text-red-400 transition-colors"
                              title="Remove tag"
                            >
                              <HiXCircle className="text-xs" />
                            </button>
                          </span>
                        ))
                      ) : (
                        <span className="text-xs text-gray-500 dark:text-gray-400">No tags assigned</span>
                      )}
                    </div>
                    <div className="flex gap-2">
                      <TextInput
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                        placeholder="Add new tag..."
                        sizing="sm"
                        className="flex-1"
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddTag();
                          }
                        }}
                      />
                      <Button
                        color="primary"
                        size="sm"
                        onClick={handleAddTag}
                        disabled={loading || !newTag.trim()}
                      >
                        <HiPlus className="text-sm" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Remarks Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Remarks</h3>
              <div className="space-y-3">
                {/* Add Remark */}
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Add New Remark</Label>
                  <textarea
                    value={newRemark}
                    onChange={(e) => setNewRemark(e.target.value)}
                    placeholder="Add a remark..."
                    className="w-full px-2.5 py-1.5 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                    rows={3}
                  />
                  <Button 
                    color="primary" 
                    size="sm" 
                    onClick={handleAddRemark}
                    disabled={loading || !newRemark.trim()}
                    className="mt-2"
                  >
                    {loading ? "Adding..." : "Add Remark"}
                  </Button>
                </div>

                {/* Remarks List */}
                <div className="flex flex-col">
                  <Label className="mb-1 text-sm">Previous Remarks</Label>
                  <div className="border border-gray-200 dark:border-gray-600 rounded-lg max-h-60 overflow-y-auto">
                    <div className="p-3">
                      {remarks.length > 0 ? (
                        <div className="space-y-3">
                          {remarks.map((remark, index) => (
                            <div key={index} className="pb-3 border-b border-gray-200 dark:border-gray-600 last:border-b-0 last:pb-0">
                              <div className="flex items-start justify-between gap-3">
                                <div className="flex-1">
                                  <div className="flex items-center gap-2 mb-2">
                                    <div className="w-6 h-6 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                                      <span className="text-blue-600 dark:text-blue-300 text-xs font-semibold">
                                        {creatorName.charAt(0).toUpperCase()}
                                      </span>
                                    </div>
                                    <span className="text-sm font-medium text-gray-900 dark:text-white">
                                      {creatorName}
                                    </span>
                                    <span className="text-xs text-gray-500 dark:text-gray-400">{remark.date}</span>
                                  </div>
                                  {editingRemarkIndex === index ? (
                                    <div className="ml-8 space-y-2">
                                      <textarea
                                        value={editingRemarkContent}
                                        onChange={(e) => setEditingRemarkContent(e.target.value)}
                                        className="w-full px-2.5 py-1.5 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                                        rows={3}
                                      />
                                      <div className="flex gap-2">
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={handleSaveEditRemark}
                                          disabled={loading || !editingRemarkContent.trim()}
                                        >
                                          <HiSave className="text-sm mr-1" />
                                          Save
                                        </Button>
                                        <Button
                                          color="gray"
                                          size="sm"
                                          onClick={handleCancelEditRemark}
                                          disabled={loading}
                                        >
                                          Cancel
                                        </Button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="text-sm text-gray-700 dark:text-gray-300 ml-8 leading-relaxed">
                                      {remark.content}
                                    </div>
                                  )}
                                </div>
                                {editingRemarkIndex !== index && (
                                  <div className="flex items-center gap-1">
                                    <button 
                                      className="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                      onClick={() => handleEditRemark(index)}
                                      disabled={loading}
                                      title="Edit remark"
                                    >
                                      <HiOutlinePencilAlt className="text-sm" />
                                    </button>
                                    <button 
                                      className="text-gray-400 hover:text-red-600 dark:hover:text-red-400 p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                      onClick={() => handleDeleteRemark(index)}
                                      disabled={loading}
                                      title="Delete remark"
                                    >
                                      <HiTrash className="text-sm" />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-sm text-gray-500 dark:text-gray-400 text-center py-6">
                          No remarks yet. Add your first remark above.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ImportDealsModal: FC<{ onUpdate: () => void }> = ({ onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null) as any;
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (selected) setFile(selected);
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await dealService.bulkUploadDeals(formData);
      if (response.data.errors && response.data.errors.length > 0) {
        toast.error(`Upload completed with ${response.data.errors.length} errors. Check console for details.`);
        console.error("Upload errors:", response.data.errors);
      } else {
        toast.success(`Successfully uploaded ${response.data.created} deals`);
      }
      onUpdate();
      setOpen(false);
      setFile(null);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Upload failed");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  function downloadDealTemplateHeadersOnly() {
    const headers = [
      "dealName",
      "description",
      "companyName",
      "amount",
      "expectedClosingDate",
      "stage",
      "remark",
      "tags",
      "contactNames",
    ];

    // Create worksheet with one empty row, using headers
    const worksheet = XLSX.utils.json_to_sheet([{}], { header: headers });

    // Ensure headers appear in the desired order
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    XLSX.writeFile(workbook, "deal_template.xlsx");
  }

  return (
    <>
      <Button color="gray" onClick={() => setOpen(true)}>
        <div className="flex items-center gap-x-3">
          <HiUserAdd className="text-xl" />
          <span>Import Excel</span>
        </div>
      </Button>
      <Modal onClose={() => setOpen(false)} show={isOpen} size="md" dismissible>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Import Deals from Excel</strong>
        </Modal.Header>
        <Modal.Body className="!p-4">
          <div className="space-y-4">
            <div>
              <Label className="mb-2 block text-sm font-medium">
                Upload Excel File
              </Label>
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 dark:placeholder-gray-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
              {file && (
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                  Selected: {file.name}
                </p>
              )}
            </div>
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
              <p className="text-sm text-blue-800 dark:text-blue-200">
                <strong>Note:</strong> The Excel file should contain columns for: dealName, companyName, amount, expectedClosingDate. 
                Any additional columns will be stored as unstructured data and can be searched.
              </p>
            </div>
            <div className="flex gap-2">
              <Button
                color="gray"
                size="sm"
                onClick={downloadDealTemplateHeadersOnly}
              >
                <HiDocumentDownload className="text-sm mr-1" />
                Download Template
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button
              color="gray"
              onClick={() => {
                setOpen(false);
                setFile(null);
              }}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleUpload}
              disabled={loading || !file}
            >
              {loading ? "Uploading..." : "Upload"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserListPage;
